import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/system'
import { useState } from 'react'
import { useAlert } from 'react-alert'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import useIsMounted from './useIsMounted'

export const useDefaultComponentTools = (
	defaultLoadingValue
) => {
	const alert = useAlert()
	const dispatch = useDispatch()
	const isMounted = useIsMounted()
	const {t} = useTranslation()
	const [loading, setLoading] = useState(defaultLoadingValue || false)
	const theme = useTheme()
	const smDown = useMediaQuery(theme.breakpoints.down('sm'))
	const mdDown = useMediaQuery(theme.breakpoints.down('md'))
	const xxlDown = useMediaQuery(theme.breakpoints.down('xxl'))
	const xlDown = useMediaQuery(theme.breakpoints.down('xl'))
	const mdUp = useMediaQuery(theme.breakpoints.up('md'))
	const lgUp = useMediaQuery(theme.breakpoints.up('lg'))
	const lgDown = useMediaQuery(theme.breakpoints.down('lg'))

	return {
		alert,
		dispatch,
		isMounted,
		lgDown,
		lgUp,
		loading,
		mdDown,
		mdUp,
		setLoading,
		smDown,
		t,
		theme,
		xlDown,
		xxlDown
	}
}
